import { render, staticRenderFns } from "./OverlayWeb.vue?vue&type=template&id=49e19ab0"
import script from "./OverlayWeb.vue?vue&type=script&lang=js"
export * from "./OverlayWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports